
import { useContext } from 'react';

import { AppContext } from '../../../app/app-context';
import { DisplayMode } from '@r-core';
import { islandConnectionMenuConfig } from './island-connection-menu.config';
import { useActionMenuLayer } from '@r-services/render-layers';
import { islandMenuConfig } from '../island/island-menu.config';
import { SvgActionMenu } from '@r-components';

export type IslandConnectionActionProps = {
	panelId: string;
	offset?: { x?: number; y?: number };
};

export const IslandConnectionActions = (props: IslandConnectionActionProps): React.ReactElement => {
	const { panelId, offset = { x: 0, y: 0 }} = props;

	const {
		controller,
		controller: { navigation }
	} = useContext(AppContext);

	// short circuit
	if (navigation.displayMode !== DisplayMode.Overhead) return <></>;

	// Use the render layer system for better performance
	// useActionMenuLayer({
	// 	id: `island-connection-actions-${panelId}`,
	// 	x: offset.x,
	// 	y: offset.y,
	// 	angleCorrection: 0,
	// 	items: islandConnectionMenuConfig({ controller, panelId }),
	// 	priority: 0
	// });

	return <SvgActionMenu {...{
				x: offset.x,
				y: offset.y,
				angleCorrection: 0,
				items: islandConnectionMenuConfig({ controller, panelId })
			}}/>;

	// return <></>; // Element is rendered by the render layer system
};


